"use strict";
(() => {
  if (window.__kfSickDayTrackingAsset) return;
  window.__kfSickDayTrackingAsset = true;
  const META = "504381690330270";
  const TIKTOK = "D9ANFG3C77U6HL2U7OIG";
  const PRODUCT = "The KinderFarms Sick Day Ready Kit";
  let initialized = false;
  let viewTracked = false;

  const selected = (quantity = 1) => {
    const shop = window.KFSickDayShopify;
    const age = document.querySelector("[data-kf-selected-age]")?.getAttribute("data-kf-selected-age") || "6–11 yrs";
    const flavor = document.querySelector("[data-kf-selected-flavor]")?.getAttribute("data-kf-selected-flavor") || "Fruit Punch";
    return {
      age, flavor, quantity: Math.max(1, Number(quantity) || 1),
      price: Number(shop?.prices?.[age] || 44.73),
      variantId: shop?.variants?.[age + "|" + flavor] || 50220883804403
    };
  };
  const eventId = (name) => `kf-sick-day-${name.toLowerCase()}-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
  const metaData = (item) => ({
    content_ids: [String(item.variantId)], content_name: `${PRODUCT} — ${item.flavor}`,
    content_category: "Sick Day Ready Kit", content_type: "product", currency: "USD",
    value: item.price * item.quantity,
    contents: [{ id: String(item.variantId), quantity: item.quantity, item_price: item.price }]
  });
  const tiktokData = (item, id) => ({
    content_id: String(item.variantId), content_ids: [String(item.variantId)],
    content_name: `${PRODUCT} — ${item.flavor}`, content_category: "Sick Day Ready Kit",
    content_type: "product", currency: "USD", value: item.price * item.quantity,
    quantity: item.quantity, event_id: id,
    contents: [{ content_id: String(item.variantId), content_type: "product", content_name: PRODUCT, quantity: item.quantity, price: item.price }]
  });

  const loadMeta = () => {
    if (window.fbq) return;
    const fbq = window.fbq = function() { fbq.callMethod ? fbq.callMethod.apply(fbq, arguments) : fbq.queue.push(arguments); };
    if (!window._fbq) window._fbq = fbq;
    fbq.push = fbq; fbq.loaded = true; fbq.version = "2.0"; fbq.queue = [];
    const script = document.createElement("script");
    script.async = true; script.src = "https://connect.facebook.net/en_US/fbevents.js";
    document.head.appendChild(script);
    fbq("init", META);
  };
  const loadTikTok = () => {
    window.TiktokAnalyticsObject = "ttq";
    const ttq = window.ttq = window.ttq || [];
    if (ttq.load) return;
    const methods = ["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie","holdConsent","revokeConsent","grantConsent"];
    ttq.setAndDefer = (target, method) => { target[method] = function() { target.push([method].concat(Array.prototype.slice.call(arguments))); }; };
    methods.forEach((method) => ttq.setAndDefer(ttq, method));
    ttq.instance = (id) => { const instance = ttq._i[id] || []; methods.forEach((method) => ttq.setAndDefer(instance, method)); return instance; };
    ttq.load = (id) => {
      ttq._i = ttq._i || {}; ttq._i[id] = []; ttq._i[id]._u = "https://analytics.tiktok.com/i18n/pixel/events.js";
      ttq._t = ttq._t || {}; ttq._t[id] = Date.now(); ttq._o = ttq._o || {}; ttq._o[id] = {};
      const script = document.createElement("script"); script.async = true;
      script.src = `${ttq._i[id]._u}?sdkid=${id}&lib=ttq`; document.head.appendChild(script);
    };
    ttq.load(TIKTOK);
  };
  const trackCommerce = (name, item) => {
    if (!initialized || !item?.variantId) return;
    const id = eventId(name);
    window.fbq?.("trackSingle", META, name, metaData(item), { eventID: id });
    window.ttq?.track(name, tiktokData(item, id));
  };
  const trackLead = () => {
    if (!initialized) return;
    const id = eventId("Lead");
    const data = { content_name: "Sick Day Ready Kit 10% email signup", event_id: id };
    window.fbq?.("trackSingle", META, "Lead", data, { eventID: id });
    window.ttq?.track("SubmitForm", data);
  };
  const marketingConsented = () => {
    try {
      const osano = window.Osano?.cm;
      if (osano) {
        if (osano.marketing === true) return true;
        const consent = osano.getConsent?.();
        if (consent && consent.MARKETING === "ACCEPT") return true;
        return false;
      }
    } catch {}
    try {
      const privacy = window.Shopify?.customerPrivacy;
      if (privacy && typeof privacy.marketingAllowed === "function") return privacy.marketingAllowed();
    } catch {}
    return false;
  };
  const initialize = () => {
    if (initialized) return;
    if (!marketingConsented()) return;
    initialized = true; loadMeta(); loadTikTok();
    window.fbq?.("trackSingle", META, "PageView");
    if (!viewTracked) { viewTracked = true; trackCommerce("ViewContent", selected()); }
  };
  /* This LP uses a bare custom layout, so Shopify's consent-tracking API is never
     loaded by the theme — without it customerPrivacy stays undefined and the gate
     above never opens. Request the feature explicitly. */
  let privacyApiRequested = false;
  const requestPrivacyApi = () => {
    if (window.Shopify?.customerPrivacy || privacyApiRequested) return;
    if (typeof window.Shopify?.loadFeatures === "function") {
      privacyApiRequested = true;
      window.Shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], () => initialize());
    }
  };

  window.KFSickDayTracking = Object.freeze({
    trackCommerce: (name, item, quantity) => trackCommerce(name, { ...item, quantity: Math.max(1, Number(quantity) || 1) }),
    trackLead
  });
  document.addEventListener("visitorConsentCollected", initialize);
  try { window.Osano?.cm?.addEventListener?.("osano-cm-consent-saved", initialize); } catch {}
  let attempts = 0;
  const timer = window.setInterval(() => { attempts += 1; requestPrivacyApi(); initialize(); if (initialized || attempts >= 120) clearInterval(timer); }, 250);
  document.addEventListener("click", (event) => {
    if (event.target.closest?.("[data-sick-checkout]")) {
      const quantity = parseInt(document.querySelector("[data-drawer-qty]")?.textContent || "1", 10) || 1;
      trackCommerce("InitiateCheckout", selected(quantity));
    }
  }, true);
  const originalFetch = window.fetch.bind(window);
  window.fetch = async function(input, init) {
    const response = await originalFetch(input, init);
    try {
      const url = typeof input === "string" ? input : input?.url || "";
      if (response.ok && /\/cart\/add(?:\.js)?(?:\?|$)/.test(url)) {
        let quantity = 1;
        try { const body = JSON.parse(typeof init?.body === "string" ? init.body : "{}"); quantity = Number(body?.items?.[0]?.quantity || body?.quantity || 1); } catch {}
        trackCommerce("AddToCart", selected(quantity));
      } else if (response.ok && /\/api\/klaviyo\/subscribe(?:\?|$)/.test(url)) trackLead();
    } catch {}
    return response;
  };
})();
